import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { FaArrowRight } from 'react-icons/fa';
import {
  staggerContainer,
  staggerItem,
  defaultViewport,
  getRevealProps,
} from '../motion/scrollMotion';
import ScrollReveal from './ScrollReveal';
import { blogPosts } from '../config/blogPosts';
import './ResourcesSection.css';

// Show the three most recent real articles from the resource library.
const resources = blogPosts.slice(0, 3);

const ResourcesSection = () => {
  return (
    <ScrollReveal as="section" className="resources-section" variant="fadeUp">
      <div className="resources-arc"></div>
      <div className="resources-container">
        <motion.div className="resources-header" {...getRevealProps('slideLeft')}>
          <h2 className="resources-title">Get the Latest Resources</h2>
          <Link to="/resources" className="resources-see-all">See All Resources</Link>
        </motion.div>

        <motion.div
          className="resources-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          {resources.map((r) => (
            <motion.div key={r.slug} className="resource-card" variants={staggerItem}>
              <span className="resource-tag">{r.tag}</span>
              <h3 className="resource-title">{r.title}</h3>
              <p className="resource-desc">{r.excerpt}</p>
              <Link to={`/blog/${r.slug}`} className="resource-cta">
                Read More
                <span className="resource-cta-arrow"><FaArrowRight /></span>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </ScrollReveal>
  );
};

export default ResourcesSection;
